export const state = {
    regulation_versions: [], //used by validations questions and validation management
    regulation_versions_transformed: null,
    validation_checks: [], // will be set per regulation version
    validation_checks_transformed: [], //version used on affidavit-valdiation-modal
    validation_checks_loading_status: null, // set loading for ui

    current_active_legislation: null,
    new_selected_legislation: null,
    affidavit_checks_changed: [],

    // validation-management
    selected_regulation_version_details: null, // for setting heading on ui, also first load
    selected_check_details: null, // for setting heading on ui
    checks_by_regulation_version: null,
    options_per_check: null,
};

export const getters = {};

export const actions = {
    setSelectedRegulationVersionDetails({ commit }, data) {
        commit("setSelectedRegulationVersionDetails", data);
    },
    setSelectedCheckDetails({ commit }, data) {
        commit("setSelectedCheckDetails", data);
    },
    setAffidavitChecksChanged({ commit }, data) {
        commit("setAffidavitChecksChanged", data);
    },
    setCurrentlActiveLegislation({ commit }, data) {
        commit("setCurrentlActiveLegislation", data);
    },
    setNewSelectedLegislation({ commit }, data) {
        commit("setNewSelectedLegislation", data);
    },
    setValiationChecksLoadinStatus({ commit }, value) {
        commit("setValiationChecksLoadinStatus", value);
    },
    //eslint-disable-next-line
    setRegulationVersions({ commit, state }, certificate_id) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/validations/getregulationversions", {
                    params: certificate_id,
                })
                //eslint-disable-next-line
                .then((response) => {
                    commit("setRegulationVersions", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setValidationChecksByCertificate({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            commit("setValiationChecksLoadinStatus", true);
            window.axios
                .get("api/validations/getvalidationchecksbycertificate", {
                    params: requestObject,
                })
                //eslint-disable-next-line
                .then((response) => {
                    commit("setValiationChecksLoadinStatus", false);
                    commit("setValidationChecksByCertificate", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setActiveCertificateRegulationVersion({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/setactivecertificateregulationversion", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    // !
    //eslint-disable-next-line
    saveCertificateValidationAnswer({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/savecertificatevalidationanswer", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    ///////////////////////
    /**
     * validation management
     */
    ///////////////////////

    //eslint-disable-next-line
    setValidationChecksByRegulationVersion({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/validations/getvalidationchecksbyregulationversion", {
                    params: requestObject,
                })
                //eslint-disable-next-line
                .then((response) => {
                    commit("setValidationChecksByRegulationVersion", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //validation option by check id
    //eslint-disable-next-line
    setCheckOptions({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/validations/getvalidationoptions", {
                    params: requestObject,
                })
                //eslint-disable-next-line
                .then((response) => {
                    commit("setCheckOptions", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    saveCreateRegulationVersion({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/addregulationversion", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    saveCreateValidationCheck({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/addvalidationcheck", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    saveCreateValidationOption({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/addvalidationoption", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },

    //eslint-disable-next-line
    saveSetRegulationCheck({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/setregulationcheck", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line

    //////
    // certifiacte authentication
    ////////

    //eslint-disable-next-line
    saveAuthenticationProof({ commit }, requestObject) {
        const formData = new FormData();

        for (let data in requestObject) {
            formData.append(data, requestObject[data]);
        }
        const headers = { "Content-Type": "multipart/form-data" };
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/saveauthenticationproof", formData, { headers })
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
};

export const mutations = {
    setRegulationVersions(state, payload) {
        state.regulation_versions = [...payload];
    },
    setValidationChecksByCertificate(state, payload) {
        // let transformedArray = [];
        state.validation_checks_transformed = null;
        state.validation_checks_transformed = [];

        for (let i = 0; i < payload.length; i++) {
            // let templateObject = null;
            let templateObject = {
                answer: "",
                id: "",
                prompt: "",
                options: [],
            };

            templateObject.id = payload[i].id;
            templateObject.prompt = payload[i].prompt;
            templateObject.options.push({ value: "unselected", text: "-- Unanswered --", disabled: true });

            //null case
            if (payload[i].answer == null || payload[i].answer == "undefined") {
                templateObject.answer = "unselected";
            } else {
                templateObject.answer = `${payload[i].id}.${payload[i].answer}`;
            }

            let currentOptions = payload[i].options;

            //transform options
            for (let j = 0; j < currentOptions.length; j++) {
                templateObject.options.push({
                    value: `${payload[i].id}.${currentOptions[j].toLowerCase()}`,
                    text: `${currentOptions[j]}`,
                });
            }
            state.validation_checks_transformed.push(templateObject);
        }

        // return transformedArray;
    },
    setValidationChecksByRegulationVersion(state, payload) {
        state.checks_by_regulation_version = payload;
    },
    setSelectedRegulationVersionDetails(state, payload) {
        state.selected_regulation_version_details = payload;
    },
    setCheckOptions(state, payload) {
        state.options_per_check = payload;
    },
    setSelectedCheckDetails(state, payload) {
        state.selected_check_details = payload;
    },
    setAffidavitChecksChanged(state, payload) {
        if (payload == -1) {
            state.affidavit_checks_changed = [];
        } else {
            state.affidavit_checks_changed = [];
            state.affidavit_checks_changed = payload;
        }
    },
    setCurrentlActiveLegislation(state, payload) {
        state.current_active_legislation = payload;
    },
    setNewSelectedLegislation(state, payload) {
        state.new_selected_legislation = payload;
    },
    setValiationChecksLoadinStatus(state, payload) {
        state.validation_checks_loading_status = payload;
    },
};
